import { getContextComponents } from 'formiojs/utils/utils';

export const ignoreSections = {
  ignoreDisplay: {
    key: 'display',
    ignore: true },

  ignoreData: {
    key: 'data',
    ignore: true },

  ignoreValidation: {
    key: 'validation',
    ignore: true },

  ignoreApi: {
    key: 'api',
    ignore: true },

  ignoreConditional: {
    key: 'conditional',
    ignore: true },

  ignoreLogic: {
    key: 'logic',
    ignore: true },

  ignoreLayout: {
    key: 'layout',
    ignore: true } };



export const display = [
{
  key: 'label',
  ignore: true },
{
  key: 'labelPosition',
  ignore: true },
{
  key: 'labelWidth',
  ignore: true },
{
  key: 'labelMargin',
  ignore: true },
{
  key: 'placeholder',
  ignore: true },
{
  key: 'description',
  ignore: true },
{
  key: 'tooltip',
  ignore: true },
{
  key: 'tabindex',
  ignore: true },
{
  key: 'hidden',
  ignore: true },
{
  key: 'hideLabel',
  ignore: true },
{
  key: 'autofocus',
  ignore: true },
{
  key: 'dataGridLabel',
  ignore: true },
{
  key: 'disabled',
  ignore: true },
{
  key: 'tableView',
  ignore: true },
{
  key: 'modalEdit',
  ignore: true }];



export const data = [
{
  key: 'multiple',
  ignore: true },
{
  key: 'defaultValue',
  ignore: true },
{
  key: 'persistent',
  ignore: true },
{
  key: 'protected',
  ignore: true },
{
  key: 'dbIndex',
  ignore: true },
{
  key: 'encrypted',
  ignore: true },
{
  key: 'redrawOn',
  ignore: true },
{
  key: 'clearOnHide',
  ignore: true },
{
  key: 'calculateServer',
  ignore: true },
{
  key: 'allowCalculateOverride',
  ignore: true }];



export const conditional = [
{
  type: 'panel',
  title: 'Simple',
  key: 'simple-conditional',
  theme: 'default',
  components: [
  {
    type: 'select',
    input: true,
    label: 'This component should Display:',
    key: 'conditional.show',
    dataSrc: 'values',
    data: {
      values: [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' }] } },



  {
    type: 'select',
    input: true,
    label: 'When the form component:',
    key: 'conditional.when',
    dataSrc: 'custom',
    valueProperty: 'value',
    data: {
      custom(context) {
        return getContextComponents(context);
      } } },


  {
    type: 'textfield',
    input: true,
    label: 'Has the value:',
    key: 'conditional.eq' },

  {
    type: 'hidden',
    key: 'customConditional',
    input: false,
    clearOnHide: false,
    calculateValue: `
          value = "show = (component.conditional.show === null) || ((component.conditional.show === true) && ((data[component.conditional.when] ? data[component.conditional.when].value : null) === component.conditional.eq))";
        ` }] },



{
  key: 'customConditionalPanel',
  ignore: true }];



export const validation = [
{
  weight: 10,
  type: 'checkbox',
  label: 'Required',
  tooltip: 'A required field must be filled in before the form can be submitted.',
  key: 'validate.required',
  input: true },

{
  key: 'unique',
  ignore: true },

{
  weight: 0,
  type: 'select',
  key: 'validateOn',
  defaultValue: 'change',
  input: true,
  label: 'Validate On',
  tooltip: 'Determines when this component should trigger front-end validation.',
  dataSrc: 'values',
  data: {
    values: [
    { label: 'Change', value: 'change' },
    { label: 'Blur', value: 'blur' }] } },



{
  weight: 190,
  type: 'textfield',
  input: true,
  key: 'errorLabel',
  label: 'Error Label',
  placeholder: 'Error Label',
  tooltip: 'The label for this field when an error occurs.' },

{
  weight: 200,
  key: 'validate.customMessage',
  label: 'Custom Error Message',
  placeholder: 'Custom Error Message',
  type: 'textfield',
  tooltip: 'Error message displayed if any error occurred.',
  input: true },

{
  key: 'custom-validation-js',
  ignore: true },

{
  key: 'json-validation-json',
  ignore: true }];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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